export const TRACTOR_MODELS = [
  "John Deere 5050D",
  "New Holland 3630",
  "Kubota MU4501",
  "Massey Ferguson 245",
  "Sonalika DI 750III",
];

 export const BRANDS = [
    ...new Set(
      TRACTOR_MODELS.map((m) => m.split(" ").slice(0, -1).join(" "))
    ),
  ];

  export const MODEL_NUMBERS = [
    ...new Set(TRACTOR_MODELS.map((m) => m.split(" ").slice(-1)[0])),
  ];

export const ENGINE_TYPES = ["Diesel", "Petrol", "Hybrid"];

export const TRANSMISSIONS = ["Manual", "Automatic", "Hydrostatic"];

export const YEARS = Array.from({ length: 30 }, (_, i) => 2024 - i);
